import { render, staticRenderFns } from "./deliverybill.vue?vue&type=template&id=1289d589&scoped=true&"
import script from "./deliverybill.vue?vue&type=script&lang=js&"
export * from "./deliverybill.vue?vue&type=script&lang=js&"
import style0 from "./deliverybill.vue?vue&type=style&index=0&id=1289d589&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1289d589",
  null
  
)

export default component.exports